import { useTranslation } from "react-i18next";

// ----------------------------------------------------------------------

const LANGS = [
  {
    value: "en",
    label: "English",
    icon: "/static/icons/ic_flag_en.svg",
  },
  {
    value: "fr",
    label: "Français",
    icon: "/static/icons/ic_flag_fr.svg",
  },
];

export default function useLocales() {
  const { i18n } = useTranslation();
  const langStorage = localStorage.getItem("i18nextLng");
  const currentLang =
    LANGS.find((_lang) => _lang.value === langStorage) || LANGS[1];

  const handleChangeLanguage = (newlang) => {
    console.log(newlang)
    i18n.changeLanguage(newlang);
  };

  const translate = (text) => {
    if (currentLang.value === "en") return text;
    switch (text) {
      // header
      case "Piano does not work on IOS":
        return "Le piano ne fonctionne pas sur IOS";
      case "Connect your Piano and refresh the page - does not work yet on IOS":
        return "Connectez votre Piano et actualisez la page - ne fonctionne pas encore sur IOS";
      // footer
      case "Contact me":
        return "Contactez moi";
      case "Name":
        return "Nom";
      case "send":
        return "envoyer";
      case "reset":
        return "vider";
      case "Follow":
        return "Mes réseaux";
      // label
      case "Jump":
        return "Saut";
      case "To display chords randomly on the board":
        return "Pour afficher les accords de manière aléatoire";
      case "Play chords like a pro without help":
        return "Jouez les accords comme un pro sans aide";
      case "Chords":
        return "Accords";
      case "Hide":
        return "Cacher";
      // Chords
      case "Major Chords":
        return "Accords Majeurs";
      case "Major Chords 1st inversion":
        return "Accords Majeurs 1er renversement";
      case "Major Chords 2nd inversion":
        return "Accords Majeurs 2em renversement";
      case "Minor Chords":
        return "Accords Mineurs";
      case "Minor Chords 1st inversion":
        return "Accords Mineurs 1er renversement";
      case "Minor Chords 2nd inversion":
        return "Accords Mineurs 2em renversement";
      case "Diminished Chords":
        return "Accords Diminués";
      case "Augmented Chords":
        return "Accords Augmentés";
      // defaults
      default:
        return text;
    }
  };

  const translateNote = (note) => {
    if (currentLang.value === "en") return note;
    const split = note.split("/");
    if (split.length === 2)
      return `${translateNote(split[0])}/${translateNote(split[1])}`;
    switch (note[0]) {
      case "C":
        return "Do" + note.slice(1);
      case "D":
        return "Ré" + note.slice(1);
      case "E":
        return "Mi" + note.slice(1);
      case "F":
        return "Fa" + note.slice(1);
      case "G":
        return "Sol" + note.slice(1);
      case "A":
        return "La" + note.slice(1);
      case "B":
        return "Si" + note.slice(1);
      // defaults
      default:
        return note;
    }
  };

  return {
    onChangeLang: handleChangeLanguage,
    translate,
    translateNote,
    currentLang,
    allLang: LANGS,
  };
}
